module.exports = __webpack_public_path__ + "img/404.f22211b0.svg";